import { FEATURE_TOGGLE_KEP_MAINTENANCE, KEP_MAINTENANCE_MESSAGE } from 'env';
import Toast from 'components/Toast';

const fallbackMessage = 'KEP podpisovanie je momentálne v údržbe. Skúste to prosím neskôr.';

/**
 * Maintenance notice shown when KEP signing is temporarily unavailable.
 */
export default function KepMaintenanceNotice() {
  if (!FEATURE_TOGGLE_KEP_MAINTENANCE) {
    return null;
  }

  return (
    <Toast
      type="warning"
      size="l"
      fullWidth
      withCloseButton={false}
      message={KEP_MAINTENANCE_MESSAGE || fallbackMessage}
    />
  );
}
